<template>
	<div class="form-group" :class="{ 'has-error': hasError }">
		<label v-if="labelText !==''" :for="id"> {{ labelText }} </label>

		<input
			:value="value"
			@input="handleInput"
			@focus="pushDatalayer"
			@blur="$emit('blur')"
			@keydown.enter="handleEnter"
			@keydown="$emit('keydown', $event)"
			:class="{
				'disabled': disabled
			}"
			:id="id"
			:placeholder="placeholder"
			:maxlength="maxLength"
			:disabled="disabled"
			:type="visibility"
			:ref="inputRef"
			:autocomplete="autocomplete"
			spellcheck="false"
			class="form-control"
			tabindex="1"/>
		<slot></slot>

		<p v-show="hasError" class="help-block" v-html="overrideErrorText"></p>
	</div>
</template>

<script>

export default {
	name: 'formInput',
	introduction: 'Vujs input form component',
	props: {
		autocomplete: {
			type: String,
			default: 'off',
			required: false,
			note: 'Set autocomplete attribute value'
		},
		value: {
			type: String,
			default: '',
			note: 'Form input value'
		},
		type: {
			type: String,
			default: 'text',
			note: 'Set input type'
		},
		id: {
			type: String,
			default: '',
			note: 'Set id'
		},
		labelText: {
			type: String,
			default: '',
			note: 'Label text'
		},
		placeholder: {
			type: String,
			default: '',
			note: 'Place holder text inside form'
		},
		maxLength: {
			type: Number,
			default: 524288,
			note: 'Set max number of length'
		},
		disabled: {
			type: Boolean,
			default: false,
			note: 'Set disable when it needed'
		},
		enterHandler: {
			type: Function,
			note: 'Keyboard enter key handler'
		},
		inputRef: {
			type: String,
			default: 'inputRef',
			note: 'Selector to choose specific element'
		},
		overrideErrorText: {
			type: String,
			default: null,
			note: 'Replace error Text'
		},
		hasError: {
			type: Boolean,
			default: false,
			note: 'Show error text'
		},
		showPass: {
			type: Boolean,
			default: null,
		},
	},
	data() {
		return {
			internalValueCopy: '',
		};
	},
	computed: {
		pathName() {
			return this.$route.name;
		},
		visibility() {
			// eslint-disable-next-line no-nested-ternary
			return this.showPass === null ? this.type :
				this.showPass === false ? 'password' :
					'text';
		},
	},
	methods: {
		handleInput(event) {
			const value = event.target.value;
			this.internalValueCopy = value;
		},
		handleEnter(e) {
			if (typeof this.enterHandler === 'function') {
				e.preventDefault();
				this.enterHandler();
			}
		},
		pushDatalayer() {
			this.$emit('focus');
			dataLayer.push({
				event: 'formFieldFocus',
				formName: this.pathName,
				fieldName: this.name
			});
		},
	},
	watch: {
		value(modifiedVal) {
			this.internalValueCopy = modifiedVal;
		},
		internalValueCopy(modifiedVal) {
			this.$emit('input', modifiedVal);
		},
	},
	mounted() {
		this.internalValueCopy = this.value;
	},
};
</script>
